// extracted by mini-css-extract-plugin
export default {"menu":"Sidebar_menu__g7YLg","menuIsClosed":"Sidebar_menuIsClosed__PiFnd","userInfo":"Sidebar_userInfo__A54OC","active":"Sidebar_active__ZLplo"};